import { render, staticRenderFns } from "./ApplicationCollateral.vue?vue&type=template&id=092b2064&lang=pug&"
import script from "./ApplicationCollateral.vue?vue&type=script&lang=js&"
export * from "./ApplicationCollateral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports